import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setLanguage } from "../../redux/features/languageSlice";
import { useTranslation } from "react-i18next";
import Flag from "react-world-flags";

const LanguageSwitcherNew = () => {
  const dispatch = useDispatch();
  const { i18n } = useTranslation();
  const currentLang = useSelector((state) => state.language.lang);

  const [open, setOpen] = useState(false);

  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setOpen(false);
      }
    };

    const handleFocusOut = (e) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(e.relatedTarget)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    document.addEventListener("focusin", handleFocusOut);

    return () => {
      document.removeEventListener("click", handleClickOutside);
      document.removeEventListener("focusin", handleFocusOut);
    };
  }, []);

  const changeLanguage = (lng) => {
    dispatch(setLanguage(lng));
    i18n.changeLanguage(lng);
    setOpen(false);
  };

  const langLabel = currentLang === "de" ? "DE" : "EN";

  return (
    <div ref={dropdownRef} className="w-100" style={{ cursor: "pointer" }}>
      {/* Parent row */}
      <div
        className="dropdown-hover-custom dropdown-item d-flex align-items-center justify-content-between ps-2"
        onClick={() => setOpen(!open)}
      >
        <div className="d-flex align-items-center">
          <i className="fas fa-globe me-3"></i>
          <span>{langLabel}</span>
        </div>

        <i className={`fas fa-chevron-${open ? "up" : "down"}`}></i>
      </div>

      {open && (
        <div className="pb-2">
          <div
            className="dropdown-item d-flex align-items-center"
            style={{ backgroundColor: "var(--secondary-light-color)" }}
            onClick={() => changeLanguage("de")}
          >
            <Flag code="DE" style={{ width: "20px", height: "15px" }} />
            <span className="ms-2 text-white">Deutsch</span>
          </div>

          <div
            className="dropdown-item d-flex align-items-center"
            style={{ backgroundColor: "var(--secondary-light-color)" }}
            onClick={() => changeLanguage("en")}
          >
            <Flag code="GB" style={{ width: "20px", height: "15px" }} />
            <span className="ms-2 text-white">English</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcherNew;
